import React from "react";
import { useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { errorMessage } from "../../reducers/subsite";
import { useForm } from "react-hook-form";
import SubsiteService from "../../services/subsite.service";
import UploadLogo from "./UploadLogo";
const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const CreateSubsiteModal = (props) => {
  const createErrorMessage = useSelector(errorMessage);
  const [isSubmitting, setSubmitting] = React.useState(false);
  const [file, setFile] = React.useState(null);

console.log("PROPS", props);
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      subsitename: props.subsite.subsiteName,
      code: props.subsite.abbreviation,
      poc: props.subsite.internalPOCs,
      logo: props.subsite.logoFilename,
      paymenttype: props.subsite.paymentOptions,
      id: props.subsite.id
    },
  });


  const onSubmit = async (data) => {
    data.uploadedImage = [file];
    //setSubmitting(true);
    await SubsiteService.addEditSubsite(data);

    //dispatch(createSubsite(data));
    // Resets form after submission is complete
    //resetForm();

    // Sets setSubmitting to false after form is reset
    setSubmitting(false);
    modalClose(true);
  }

  const modalClose = (value) => {
    props.closeModal(value);
  }

  var label = "Add Subsite";

  if(props.subsite.abbreviation) {
    label = "Edit Subsite";
  }

  return (
    <Modal show={props.show} onHide={() => modalClose(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{label}<br /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3" controlId="subsitename">
            <Form.Label>Name</Form.Label>
            <input {...register("subsitename", { required: true })} /><br />
            {errors.subsitename && <div className="error" >Name is required</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="code">
            <Form.Label>Code</Form.Label>
            <input {...register("code", { required: true })} /><br />
            {errors.code && <div className="error" >Code is required</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="poc">
            <Form.Label>Point of Contact</Form.Label>
            <input {...register("poc", { required: true })} /><br />
            {errors.poc && <div className="error" >Point of Contact is required</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="logo">
            <UploadLogo register={register} fieldName="logo"  currentLogo={props.subsite.logoFilename} setFile={setFile}/>
          </Form.Group>
          <Form.Group className="mb-3" controlId="paymenttype">
            <Form.Label>Payment Type</Form.Label>
            <Form.Check
              {...register("paymenttype", { required: true })}
              type="radio"
              label="Credit Card Only"
              value="creditcard"
              name="paymenttype"
            />
            <Form.Check
              {...register("paymenttype", { required: true })}
              type="radio"
              label="Balance Only"
              value="balance"
              name="paymenttype"
            />
            <Form.Check
              {...register("paymenttype", { required: true })}
              type="radio"
              label="Balance then Credit Card"
              value="balance creditcard"
              name="paymenttype"
            />

            {errors.paymenttype && <div className="error" >Payment Type is required</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="userUpdateAddress">
            <Form.Label>Address Rule</Form.Label>
            <Form.Check
              {...register("userUpdateAddress", { required: true })}
              type="radio"
              label="User can update their address"
              value="true"
              name="userUpdateAddress"
            />
            <Form.Check
              {...register("userUpdateAddress", { required: true })}
              type="radio"
              label={`All orders will be mailed to: ${props.subsite.subsiteName}`}
              value="false"
              name="userUpdateAddress"
            />
            {errors.paymenttype && <div className="error" >Payment Type is required</div>}
          </Form.Group>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => modalClose(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" onClick={handleSubmit(onSubmit)} disabled={isSubmitting}>
              {label}
            </Button>
            {createErrorMessage}
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateSubsiteModal; 